(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('FlyerCategorysNewController', FlyerCategorysNewController);

    FlyerCategorysNewController.$inject = ['$timeout', '$localStorage', '$state', '$scope', '$stateParams', '$translate', '$uibModalInstance', 'FlyerCategoryService', 'toastr'];

    function FlyerCategorysNewController($timeout, $localStorage, $state, $scope, $stateParams, $translate, $uibModalInstance, FlyerCategoryService, toastr) {
        var vm = this;

        vm.category = { key: "", languages: [ {langKey: "pt-BR", title: ""}, {langKey: "en", title: ""}, {langKey: "es", title: ""} ]};

        vm.save = save;

        function save () {
          FlyerCategoryService.createCategory(vm.category).then(function (data) {
            toastr.success($translate.instant('categorys.messages.new.success'));
            $uibModalInstance.close(true);
          }, function (data) {
            toastr.error($translate.instant('categorys.messages.new.error'));
          });
        }


    }

})();
